const common = {
  messages: {
    success: '',
    errors: '',
  },
  loading: false,
};
const getters = {
  commonErrors: state => state.messages.errors,
  commonSuccess: state => state.messages.success,
};
const actions = {
  clearSuccessMessage({ commit }) {
    commit('CLEARSUCCESSMESSAGE');
  },
};
const mutations = {
  CLEARSUCCESSMESSAGE(state) {
    state.messages.success = '';
  },
};
export default {
  namespaced: true,
  state: common,
  getters,
  actions,
  mutations,
};
